<template lang="">
  <b-row>
    <b-col>
      <p v-if="coupon_is_enabled" class="alert alert-info">
        With {{ $store.state.global_coupon.percentage_off }}% coupon, only
        <strong>{{ (product.amount / 100) | toCurrency }}</strong>
      </p>

      <b-btn
        v-if="!$store.state.authorized"
        v-b-modal="modalId"
        variant="primary"
      >
        Sign up
      </b-btn>
      <b-modal
        v-if="!$store.state.authorized"
        :id="modalId"
        :hide-footer="true"
        title="Create Account"
      >
        <CreateAccount />
      </b-modal>

      <form v-if="show_purchase_button" :action="payment_url" method="POST">
        <StripeCheckout
          :stripe-key="public_key"
          :product="product"
          :form-id="formId"
        />
      </form>
      <b-btn
        v-if="show_upgrade_button"
        :to="{ name: 'upgrade-prorate', params: { plan_id: plan_id } }"
        variant="primary"
      >
        Upgrade
      </b-btn>
      <p v-if="show_paypal_upgrade_info">
        PayPal subscribers, please contact
        <a href="mailto:help@tungite.com">support</a> for pro-rated upgrade
        options.
      </p>
      <h4 v-if="existing_user_plan_id == plan_id">
        <v-icon name="check-circle" class="green" /> Your current plan
      </h4>
      <p v-if="show_purchase_button && !coupon_is_enabled" class="small mt-2">
        Purchases use Stripe for card processing.<br />
        <!-- Or
        <b-link
          :to="{ name: 'upgrade-paypal', params: { plan_id: plan_slug } }"
        >
          use PayPal
        </b-link>
        instead. -->
      </p>
    </b-col>
  </b-row>
</template>

<script>
import StripeCheckout from "@/components/StripeCheckout";
import {
  stripe_public_key,
  plans,
  stripe_payment_endpoint,
  global_coupon
} from "@/defaults";
import CreateAccount from "@/components/CreateAccount.vue";
export default {
  name: "StripePlan",
  components: {
    StripeCheckout,
    CreateAccount
  },
  filters: {
    toCurrency: function(value) {
      if (typeof value !== "number") {
        return value;
      }
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2
      });
      return formatter.format(value);
    }
  },
  props: {
    plan_slug: {
      type: String,
      default: () => ""
    },
    coupon_override: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {};
  },
  computed: {
    coupon() {
      return global_coupon;
    },
    show_purchase_button() {
      return (
        this.$store.state.authorized && this.existing_user_plan_id == "trial"
      );
    },
    show_upgrade_button() {
      return (
        this.$store.state.authorized &&
        this.existing_user_plan_id != "trial" &&
        this.existing_user_plan.amount < this.product.amount &&
        this.$store.state.user_doc.subscribed_source != "paypal"
      );
    },
    show_paypal_upgrade_info() {
      return (
        this.$store.state.authorized &&
        this.existing_user_plan_id != "trial" &&
        this.existing_user_plan.amount < this.product.amount &&
        this.$store.state.user_doc.subscribed_source == "paypal"
      );
    },
    existing_user_plan() {
      if (this.$store.getters.user_plan) {
        return this.$store.getters.user_plan;
      } else {
        return { amount: 0 };
      }
    },
    existing_user_plan_id() {
      if (this.$store.getters.user_plan) {
        return this.$store.getters.user_plan.plan_id;
      } else {
        return null;
      }
    },
    modalId() {
      return "signup_modal_" + this.plan_slug;
    },
    formId() {
      return "stripe_form_" + this.plan_slug;
    },
    payment_url() {
      if (this.coupon_is_enabled) {
        return (
          stripe_payment_endpoint +
          "subscribe_charge_coupon/" +
          this.$store.state.user.uid +
          "/" +
          this.plan_id +
          "/"
        );
      } else {
        return (
          stripe_payment_endpoint +
          "subscribe_charge/" +
          this.$store.state.user.uid +
          "/" +
          this.plan_id +
          "/"
        );
      }
    },
    public_key() {
      return stripe_public_key;
    },
    plan_id() {
      return plans[this.plan_slug].plan_id;
    },
    coupon_is_enabled() {
      return this.coupon.enabled || this.coupon_override;
    },
    product() {
      var plan = plans[this.plan_slug];
      var product = {
        name: plan.name,
        description: plan.description,
        amount: plan.amount
      };
      if (this.coupon_is_enabled) {
        product.amount =
          product.amount * ((100 - this.coupon.percentage_off) / 100);
        product.description = `${plan.description} (${this.coupon.percentage_off}% off)`;
      }
      return product;
    }
  }
};
</script>

<style lang="scss" scoped>
.green {
  color: green;
}
</style>
